import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BONUS_KICKER, BONUS_TOTAL, bonuses } from '../data/sushiContent';
export function BonusesSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="bonuses-title" data-id="element-21" data-mp="gxzw1aavt7tn">
      <div className="mx-auto max-w-5xl px-5" data-id="element-22" data-mp="qtt70p8yct9b">
        <p className="text-center text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-23" data-mp="qt0a0fzspi4d">
          Siempre incluidos
        </p>
        <h2 id="bonuses-title" className="mt-3 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-24" data-mp="zuhlfl29cvmq">
          + 3 Bonos estratégicos
        </h2>
        <p className="mt-3 text-center text-[14px] leading-snug text-body" data-id="element-25" data-mp="19k152sxsotin">
          {BONUS_KICKER}
        </p>

        <ul className="mt-9 grid gap-x-5 gap-y-10 sm:grid-cols-3" data-id="element-26" data-mp="1nkvfti8bf6kh">
          {bonuses.map(b => <li key={b.number} className="flex flex-col text-center" data-id="element-27" data-mp="1jjryeramd2h5">
              <img src={b.image} alt={`Bono ${b.number}: ${b.title} — ${b.subtitle}`} className="mx-auto w-full max-w-[13rem] object-contain" width={1080} height={1350} loading="lazy" data-id="element-28" data-mp="3pqtswiae5tds" />
              <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.22em] text-champagne" data-id="element-29" data-mp="7l8hf841tmrq">
                Bono {b.number}
              </p>
              <h3 className="mt-1 font-display text-lg font-semibold uppercase leading-tight text-ivory-50" data-id="element-30" data-mp="cjjtzqlqabdn">
                {b.title}
              </h3>
              <p className="mx-auto mt-1.5 max-w-[15rem] text-[13px] leading-snug text-body" data-id="element-31" data-mp="lbu12z1bu0qo">
                {b.subtitle}
              </p>

              <ul className="mx-auto mt-4 w-full max-w-[15rem] space-y-1.5 text-left" data-id="element-32" data-mp="qaf1aygkwkf4">
                {b.benefits.map(benefit => <li key={benefit} className="flex items-start gap-2" data-id="element-33" data-mp="1094lwyzv0iz2">
                    <CheckIcon className="mt-1 h-3 w-3 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-34" data-mp="1079xvbtakaqr" />
                    <span className="text-[13px] leading-snug text-ivory-200" data-id="element-35" data-mp="5kb5mo3ox7dv">
                      {benefit}
                    </span>
                  </li>)}
              </ul>

              <p className="mt-auto pt-4 text-[10px] font-semibold uppercase tracking-[0.16em]" data-id="element-36" data-mp="fih754ll4bi7">
                <span className="text-muted line-through" data-id="element-37" data-mp="tdt9ny5zf69o">Valor: {b.value} USD</span>
                <span className="ml-2 text-champagne" data-id="element-38" data-mp="ocdsih6xdjwk">Gratis</span>
              </p>
            </li>)}
        </ul>

        <p className="mt-10 border-y border-champagne/25 py-5 text-center text-[13px] font-semibold uppercase tracking-[0.18em] text-ivory-100" data-id="element-39" data-mp="yatk0l9v6v6l">
          Valor total de bonos{' '}
          <span className="text-muted line-through" data-id="element-40" data-mp="353dk89wsg9sf">{BONUS_TOTAL}</span>
          <span className="ml-3 text-champagne" data-id="element-41" data-mp="303hnmvqf7kmw">→ Gratis con tu compra</span>
        </p>
      </div>
    </section>;
}